import React, { useState, useEffect } from "react";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { loadModules } from "esri-loader";
import style from "./form.module.scss";
import ROADS_NPM_KPI from './KPI/road_npm_kpi';
import { Formik, Form } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import { useKPIs } from "../../context/KPIsContext";
import { AIRPORTS_IMP_PM_KPI_INIT, AIRPORTS_LIVE_PM_KPI_INIT, AIRPORTS_NPM_KPI_INIT, BORDER_CROSSING_NPM_KPI_INIT, FREIGHT_LIVE_PM_KPI_INIT, FREIGHT_TERMINAL_IMP_PM_KPI_INIT, FREIGHT_TERMINAL_NPM_KPI_INIT, IWWP_IMP_PM_KPI_INIT, IWWP_LIVE_PM_KPI_INIT, IWW_IMP_PM_KPI_INIT, IWW_LIVE_PM_KPI_INIT, IWW_NPM_KPI_INIT, IWW_PORTS_NPM_KPI_INIT, RAILWAYS_IMP_PM_KPI_INIT, RAILWAYS_LIVE_PM_KPI_INIT, RAILWAYS_NPM_KPI_INIT, ROADS_NPM_KPI_INIT, ROADS_SAFETY_KPI_INIT, ROAD_IMP_PM_KPI_INIT, ROAD_LIVE_PM_KPI_INIT, SEAPORTS_IMP_PM_KPI_INIT, SEAPORTS_LIVE_PM_KPI_INIT, SEAPORTS_NPM_KPI_INIT } from "../../.config/KPI/road_network_performance";
import ROAD_SAFETY_KPI from "./KPI/road_safety_kpi";
import RAILWAYS_NPM_KPI from "./KPI/railways_npm_kpi";
import FREIGHT_NPM_KPI from "./KPI/freight_npm_kpi";
import IWW_NPM_KPI from "./KPI/iww_npm_kpi";
import IWW_PORTS_NPM_KPI from "./KPI/iww_ports_npm_kpi";
import SEAPORTS_NPM_KPI from "./KPI/seaports_npm";
import AIRPORTS_NPM_KPI from "./KPI/airports_npm";
import ROADS_IMP_PM_KPI from "./KPI/road_imp_pm_kpi";
import ROADS_LIVE_PM_KPI from "./KPI/road_live_pm_kpi";
import ROAD_BORDER_CROSSING_NPM_KPI from "./KPI/road_border_crossing_npm_kpi";
import RAILWAYS_IMP_PM_KPI from "./KPI/railways_imp_pm_kpi";
import RAILWAYS_LIVE_PM_KPI from "./KPI/railways_live_pm_kpi";
import FREIGHT_IMP_PM_KPI from "./KPI/freight_imp_pm_kpi";
import FREIGHT_LIVE_PM_KPI from "./KPI/freight_live_pm_kpi";
import IWW_IMP_PM_KPI from "./KPI/iww_imp_pm_kpi";
import IWW_LIVE_PM_KPI from "./KPI/iww_live_pm_kpi";
import IWW_PORTS_IMP_PM_KPI from "./KPI/iww_ports_imp_pm_kpi";
import IWW_PORTS_LIVE_PM_KPI from "./KPI/iww_ports_live_pm_kpi";
import SEAPORTS_IMP_PM_KPI from "./KPI/seaports_imp_pm_kpi";
import SEAPORTS_LIVE_PM_KPI from "./KPI/seaports_live_pm_kpi";
import AIRPORTS_IMP_PM_KPI from "./KPI/airports_imp_pm_kpi";
import AIRPORTS_LIVE_PM_KPI from "./KPI/airports_live_pm_kpi";
import RAILWAYS_BORDER_CROSSING_NPM_KPI from "./KPI/railways_border_crossing_npm_kpi";
import { LOADING } from "../../components/Loading/Loading";
import { TODIS_MODAL_KPI_PERIOD } from "../../components/Modals/ModalForm/ModalKPIPeriod";
import { TODIS_MODAL_KPI_RANGE } from "../../components/Modals/ModalForm/ModalKPIRange";
import { TODIS_MODAL_KPI_NOISE } from "../../components/Modals/ModalForm/ModalKPINoise";

const FORMS = {
    //Roads
    "ROADNPM": [ROADS_NPM_KPI, ROADS_NPM_KPI_INIT, "Roads - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/23/query", "npm_road_id"],
    "ROADSAFETY": [ROAD_SAFETY_KPI, ROADS_SAFETY_KPI_INIT, "Road Safety", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/14/query", "roads_safety_id"],
    "ROADIMP": [ROADS_IMP_PM_KPI, ROAD_IMP_PM_KPI_INIT, "Roads - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/21/query", "imp_road_proj_id"],
    "ROADLIVE": [ROADS_LIVE_PM_KPI, ROAD_LIVE_PM_KPI_INIT, "Roads - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/22/query", "live_road_proj_id"],
    "ROADBORDERCROS": [ROAD_BORDER_CROSSING_NPM_KPI, BORDER_CROSSING_NPM_KPI_INIT, "Road Border Crossings - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/3/query", "npm_roads_border_cross_id"],
    "RAILWAYSNPM": [RAILWAYS_NPM_KPI, RAILWAYS_NPM_KPI_INIT, "Railways - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/20/query", "npm_rw_id"],
    "RAILWAYSIMP": [RAILWAYS_IMP_PM_KPI, RAILWAYS_IMP_PM_KPI_INIT, "Railways - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/18/query", "imp_rw_proj_id"],
    "RAILWAYSLIVE": [RAILWAYS_LIVE_PM_KPI, RAILWAYS_LIVE_PM_KPI_INIT, "Railways - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/19/query", "live_rw_proj_id"],
    "RAILWAYSBORDERCROS": [RAILWAYS_BORDER_CROSSING_NPM_KPI, BORDER_CROSSING_NPM_KPI_INIT, "Railways Border Crossings - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/4/query", "npm_rw_border_cross_id"],
    "FREIGHTNPM": [FREIGHT_NPM_KPI, FREIGHT_TERMINAL_NPM_KPI_INIT, "Freight Terminal - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/8/query", "npm_freight_id"],
    "FREIGHTIMP": [FREIGHT_IMP_PM_KPI, FREIGHT_TERMINAL_IMP_PM_KPI_INIT, "Freight Terminal - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/10/query", "imp_freight_proj_id"],
    "FREIGHTLIVE": [FREIGHT_LIVE_PM_KPI, FREIGHT_LIVE_PM_KPI_INIT, "Freight Terminal - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/9/query", "live_freight_proj_id"],
    "IWWNPM": [IWW_NPM_KPI, IWW_NPM_KPI_INIT, "Inland Waterways - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/17/query", "npm_iww_id"],
    "IWWIMP": [IWW_IMP_PM_KPI, IWW_IMP_PM_KPI_INIT, "Inland Waterways - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/15/query", "imp_iww_proj_id"],
    "IWWLIVE": [IWW_LIVE_PM_KPI, IWW_LIVE_PM_KPI_INIT, "Inland Waterways - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/16/query", "live_iww_proj_id"],
    "IWWPORTSNPM": [IWW_PORTS_NPM_KPI, IWW_PORTS_NPM_KPI_INIT, "IWW Ports - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/5/query", "npm_iww_ports_id"],
    "IWWPORTIMP": [IWW_PORTS_IMP_PM_KPI, IWWP_IMP_PM_KPI_INIT, "Inland Waterways Ports - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/7/query", "imp_iww_ports_proj_id"],
    "IWWPORTLIVE": [IWW_PORTS_LIVE_PM_KPI, IWWP_LIVE_PM_KPI_INIT, "Inland Waterways Ports - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/6/query", "live_iww_ports_proj_id"],
    "SEAPORTSNPM": [SEAPORTS_NPM_KPI, SEAPORTS_NPM_KPI_INIT, "Seaports - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/0/query", "npm_seaports_id"],
    "SEAPORTIMP": [SEAPORTS_IMP_PM_KPI, SEAPORTS_IMP_PM_KPI_INIT, "Seaports - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/2/query", "imp_seaports_proj_id"],
    "SEAPORTLIVE": [SEAPORTS_LIVE_PM_KPI, SEAPORTS_LIVE_PM_KPI_INIT, "Seaports - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/1/query", "live_seaports_proj_id"],
    "AIRPORTSNPM": [AIRPORTS_NPM_KPI, AIRPORTS_NPM_KPI_INIT, "Airports - Network Performance Monitoring", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/11/query", "npm_airports_id"],
    "AIRPORTIMP": [AIRPORTS_IMP_PM_KPI, AIRPORTS_IMP_PM_KPI_INIT, "Airports - Project Monitoring Implemented Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/13/query", "imp_airports_proj_id"],
    "AIRPORTLIVE": [AIRPORTS_LIVE_PM_KPI, AIRPORTS_LIVE_PM_KPI_INIT, "Airports - Project Monitoring Live Projects", "https://todis.transport-community.org/server/rest/services/Todis_KPIs_Services/MapServer/12/query", "live_airports_proj_id"]

}



const TODIS_FORM_KPI = ({type, filter}) => {
    
    let FormComponent = type==null ? null: FORMS[type][0];
    
    const { formatNumber } = useKPIs();

    const [dataform, setDataForm] = useState(type == null ? null : FORMS[type][1]);
    const [modalShow, setModalShow] = useState(false)
    const [modalShowRange, setModalShowRange] = useState(false)
    const [modalShowNoise, setModalShowNoise] = useState(false)
    const [dataKPI, setDataKPI] = useState([])
    const [response, setResponse] = useState(false)
    const [fieldCal, setFieldCal] = useState("")
    const [item, setItem] = useState("")
    const [typeform, setTypeForm] = useState("")
    const [fecha, setFecha] = useState("")
    const [regionalPartner, setRegionalPartner] = useState("")
    const [tentCategory, setTentCategory] = useState("")
    const [Objectid, setObjectid] = useState("")

    useEffect(() => {
        setResponse(false)
        loadModules(["esri/layers/FeatureLayer", "esri/rest/support/Query"], {
            css: true
        }).then(([FeatureLayer, Query]) => {

            var bikeTrailsRenderer = {
                type: "simple",
                symbol: {
                    type: "simple-line",
                    style: "solid",
                    color: [0, 255, 255, 0.8],
                    width: "10px",
                    outline: {
                        width: 10,
                        color: "#FFFF00"
                    }
                }
            };
            // Llamar geometria de los formularios    
            var definequery = "1=1";
            var country = "";
            var tent = "";
            var year = "";
            var yearIni = "";
            var objectid = "";
            var tentitext = "";
            if (type == "ROADLIVE") {
                tentitext = "tent_t_category";
            }
            else {
                tentitext = "ten_t_category";
            }

            if (filter.regionalPartner != "" && filter.regionalPartner != "0") {
                country = " and country_code" + " IN (" + filter.regionalPartner + ")";
            }
            if (filter.tentCategory != "" && filter.tentCategory != "0") {
                tent = " and " + tentitext + " IN (" + filter.tentCategory + ")";
            }
            if (filter.objectid != "" && filter.objectid != "0") {
                objectid = " and  " + FORMS[type][4] + " IN (" + filter.objectid + ")";
            }
            // if (filter.networkType != '1' || (filter.sector == '2' || filter.sector == '3')){
            //     if (filter.yearInit != "" && filter.yearInit != "0" )
            //     {
            //         if(filter.sector == '2'){
            //             year = " and " + "year" + " >= " + filter.yearInit + " AND "+ " year " + " <= " + (parseInt(filter.yearInit)+1)  + ""; 
            //         }else{
            //             year = " and " + "year" + " = " + filter.yearInit + "";  
            //         }              
            //     }  
            // }
            if (filter.yearInit != "" && filter.yearInit != "0") {
                yearIni = " and date_valid_from <= timestamp '" + filter.yearInit + "-12-31 00:00:00' AND date_valid_to >= timestamp '" + filter.yearInit + "-01-01 12:00:00'";
            }
            var layerElementDefault = new FeatureLayer({
                url: FORMS[type][3],
                definitionExpression: definequery + country + tent + yearIni + year + objectid,
                renderer: bikeTrailsRenderer
            });
            const query = new Query();
            query.where = definequery + country + tent + yearIni + year + objectid;
            query.outSpatialReference = { wkid: 102100 };
            query.returnGeometry = true;
            query.outFields = ["*"];
            layerElementDefault.queryFeatures(query).then(function (results) {

                //console.log(results); 
                setDataKPI(results.features);
                setTypeForm(type);
                setFecha(filter.yearInit);
                setRegionalPartner(filter.regionalPartner);
                setTentCategory(filter.tentCategory);
                setObjectid(filter.objectid);
                setResponse(true);
            });
        });
    }, [filter])

    const changeValues = (newValue) => {
        setDataForm(newValue)
    }

    const showModalCal = (field, item) => {
        setFieldCal(field)
        setItem(item)
        setModalShow(true)
    }

    const showModalCalRange = (field, item) => {
        setFieldCal(field)
        setItem(item)
        setModalShowRange(true)
    }
    const showModalCalNoise = (field, item) => {
        setFieldCal(field)
        setItem(item)
        setModalShowNoise(true)
    }
    const setPath = (object, path, value) => {
        path.split('.').reduce((o, p, i) => o[p] = path.split('.').length === ++i ? value : o[p] || {}, object)

        return object;
    }

    const onCalculatePeriod = (data) => {

        loadModules(["esri/layers/FeatureLayer", "esri/rest/support/Query"], {
            css: true
        }).then(([FeatureLayer, Query]) => {

            // Llamar geometria de los formularios    
            let rangeFrom = data.rangeFrom.year;
            var definequery = "1=1";           
            var country = "";
            var tent = "";
            var yearIni = "";
            var objectid = "";
            var tentitext = "";    

            if (typeform == "ROADLIVE") {
                tentitext = "tent_t_category";
            }
            else {
                tentitext = "ten_t_category";
            }

            if (regionalPartner != "" && regionalPartner != "0") {
                country = " and country_code" + " IN (" + regionalPartner + ")";
            }
            if (tentCategory != "" && tentCategory != "0") {
                tent = " and " + tentitext + " IN (" + tentCategory + ")";
            }
            if (Objectid != "" && Objectid != "0") {
                objectid = " and  " + FORMS[typeform][4] + " IN (" + Objectid + ")";
            }
            if (rangeFrom != "" && rangeFrom!= "0") {
                yearIni = " and date_valid_from <= timestamp '" + rangeFrom + "-12-31 00:00:00' AND date_valid_to >= timestamp '" + rangeFrom + "-01-01 12:00:00'";
            }

            var layerElementDefault = new FeatureLayer({
                url: FORMS[typeform][3],
                definitionExpression: definequery + country + tent + yearIni + objectid
            });
            const query = new Query();
            query.where = definequery + country + tent + yearIni + objectid;
            query.outSpatialReference = { wkid: 102100 };
            query.returnGeometry = true;
            query.outFields = ["*"];
            layerElementDefault.queryFeatures(query).then(function (results) {   

                let sumFrom = 0;
                let sumTo = 0;
        
                let total = 0;
                let diferencia = 0;
        
                dataKPI.filter(data => {
                    
                    if((data.attributes.year >= parseInt(fecha)))
                    {
                        if(data.attributes[item] != null && data.attributes[item] != undefined){
                            sumFrom += data.attributes[item]
                        }
                    }

                    
                });
                results.features.filter(data => {

                    if((data.attributes.year >= rangeFrom)){
                        if(data.attributes[item] != null && data.attributes[item] != undefined){
                            sumTo += data.attributes[item]
                        }
                    }
                    
                });
                
                diferencia = sumTo - sumFrom;

                total = sumFrom == 0 ? "" : formatNumber((diferencia / sumFrom) * 100);
        
                setDataForm(prevState => {
                    let newState = { ...prevState };
                    return setPath(newState, fieldCal, total)
                })
        
                setModalShow(false)     

                
            });
          
        });
       
    }
    const onCalculateRangeNoise = (data) => {

        let sumTotal = 0;
        let porcentajeNoise = 0;
        let noise = parseInt(data.fromData);

        dataKPI.filter(item => {
            if (item.attributes.noise = ! null) {

                if (item.attributes.noise > noise) {
                    sumTotal++;
                }
            }
        });

        porcentajeNoise = (sumTotal / dataKPI.length);
        setDataForm(prevState => {
            let newState = { ...prevState };
            return setPath(newState, fieldCal, porcentajeNoise)
        })

        setModalShowNoise(false)

    }
    const onCalculateRange = (data) => {

        let sumTotal = 0;
        let total = 0;
        let from = parseInt(data.fromData);
        let to = parseInt(data.toData);
        dataKPI.filter(datos => {
            if(datos.attributes[item] != null && datos.attributes[item] != undefined)
            {
                if (datos.attributes[item] >= from && datos.attributes[item] <= to) {

                    sumTotal++;
                }
            }
        });

        total = sumTotal != 0 ? formatNumber((sumTotal * 100) / dataKPI.length) : "";

        setDataForm(prevState => {
            let newState = { ...prevState };
            return setPath(newState, fieldCal, total)
        })

        setModalShowRange(false)
    }

    return (
        <Container fluid className={`${"p-4"}`} style={{ height: "calc(100vh - 121px)", backgroundColor: "#fff", borderTopLeftRadius: "30px", borderTopRightRadius: "30px" }}>
            <Formik
                style={{ height: "calc(100vh - 221px)", overflowY: "auto" }}
                enableReinitialize={true}
                initialValues={dataform}
                validate={() => { }}
                validationSchema={false}>
                {() => (
                    <>
                        <Row className="todis-form-action-panel pb-3">
                            <Col lg={12}>
                                <Stack gap={0}>
                                    <h5 className="todis-header">{FORMS[type][2]} </h5>
                                </Stack>
                            </Col>
                        </Row>

                        <Form className={style.todisFormContent} method="post" style={{ overflowY: "hidden auto", height: "calc(100vh - 216px)", marginTop: "20px" }}>
                            {
                                response ?
                                    <FormComponent data={dataKPI} changeValues={changeValues} filter={filter} showModalCal={showModalCal} showModalCalRange={showModalCalRange} showModalCalNoise={showModalCalNoise} />
                                    :
                                    <LOADING />
                            }
                        </Form>
                    </>
                )}
            </Formik>
            <TODIS_MODAL_KPI_PERIOD show={modalShow} onHide={() => setModalShow(false)} title="Defined Period" onCalculate={onCalculatePeriod} />
            <TODIS_MODAL_KPI_RANGE show={modalShowRange} onHide={() => setModalShowRange(false)} title="Data Definition by Range" onCalculate={onCalculateRange} />
            <TODIS_MODAL_KPI_NOISE show={modalShowNoise} onHide={() => setModalShowNoise(false)} title="Data Definition by Range Noise" onCalculate={onCalculateRangeNoise} />
        </Container >
    )
}

export default TODIS_FORM_KPI;